/*
 * @Author: gaobin
 * @Date: 2025-01-14 16:36:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-31 16:14:02
 * @Description: 根级别的action
 */
import request from '@/services';
import { CUR_TOKEN, CUR_USERINFO } from './mutation-types';

const actions = {
  // 登录
  async UserLogin({ commit }, userInfo) {
    const res = await request.userLogin({
      method: 'POST',
      data: userInfo.data,
    });

    if (res.success) {
      const { token } = res.data;
      commit('SET_TOKEN', token);
    }
    console.log('res搜索33', res);
    return res;
  },

  // 获取用户信息
  async GetUserInfo({ commit }, judgeParams) {
    const res = await request.getUserInfoExt({
      method: 'get',
      ...judgeParams,
    });

    if (res.success) {
      commit('SET_USER_INFO', res.data);
      return true;
    }
    return false;
  },

  // 埋点上报服务器
  async SendTracker({ commit }, params) {
    const res = await request.pushTraceExt({
      method: 'POST',
      data: params,
      bHiddenError: true,
    });

    if (res.success) {
      console.log('埋点上报成功', res);
      return true;
    }
    return false;
  },

  // 登出
  Logout({ commit, state }) {
    return new Promise((resolve) => {
      uni.removeStorage(CUR_TOKEN);
      uni.removeStorage(CUR_USERINFO);
      uni.removeStorageSync('uwebuyOrderPageNeedRefresh'); // 退出时清空一下订单刷新的标
      commit('SET_TOKEN', '');
      commit('SET_USER_INFO', {});
      resolve();
    });
  },
};

export default actions;
